export const INITAL_CLUBBED_AUTH_MODAL_BASIC_DETAILS_STATE = {
  name: '',
  age: '',
  // No preselection: a gender must be an answer, not a default that slips through.
  gender: '',
  contentLanguages: [sessionStorage.getItem('languageCode') || 'en'],
}
